import { Component, OnInit, OnDestroy } from "@angular/core";
import { Subscription } from "rxjs/Subscription";
import { Router } from "@angular/router";
import { AuthAccessProvider } from "../core/core.auth";
import {
  UserContext,
  BaseComponent,
  PrenotazioneSala,
  PrenotazioneSalaRequest,
} from "../core/core.component";
import { MessageProvider } from "../service/message.service";
import { SalaService } from "../service/sala.service";
import { AppConstants } from "../core/app.constants";
import { UfficioService } from "app/service/ufficio.service";
import { BusyProvider } from "app/service/busy.service";

declare var $: any;

@Component({
  selector: "app-detail-sala",
  templateUrl: "./sala-detail.component.html",
  styleUrls: ["././sala-detail.component.css"],
  host: { "(window:keydown)": "shortcutHandler($event)" },
})
export class DetailSalaComponent extends BaseComponent implements OnInit, OnDestroy {
  static DIALOG_ID_PRENOTA: string = "insertPrenotazioneSalaDialog";
  static DIALOG_ID_LIBERA: string = "cancellaPrenotazioneSalaDialog";
  static DIALOG_ID_MODIFICA: string = "modificaPrenotazioneSalaDialog";
  it: any = AppConstants.ITA_CALENDAR_CONF;
  userContext: UserContext;

  errorMessage: string;

  fromDate: Date = null;
  toDate: Date = null;
  hrBegin: string = null;
  hrEnd: string = null;
  descrizione: string = null;

  selectedStatoSala: PrenotazioneSala = null;

  private salaDetailStatusSubscription: Subscription;

  constructor(
    protected authAccess: AuthAccessProvider,
    protected router: Router,
    protected messageProvider: MessageProvider,
    private salaService: SalaService,
    private ufficioService: UfficioService,
    private busyProvider: BusyProvider
  ) {
    super(authAccess, router, messageProvider);
  }

  ngOnInit() {
    this.userContext = this.authAccess.getUserContext();
    if (this.userContext == null) {
      this.authAccess.invalidate();
    } else {
      this.reset();

      this.salaDetailStatusSubscription = this.salaService.getSalaDetailStatus().subscribe((operation) => {
        this.reset();
        this.fromDate = operation.date;
        this.toDate = operation.date;
        switch (operation.status) {
          case "prenota":
            $("#" + DetailSalaComponent.DIALOG_ID_PRENOTA).modal({
              backdrop: "static",
              keyboard: false,
            });
            break;
          case "libera":
            $("#" + DetailSalaComponent.DIALOG_ID_LIBERA).modal({
              backdrop: "static",
              keyboard: false,
            });
            this.selectedStatoSala = operation.stato;
            break;
          case "modifica":
            $("#" + DetailSalaComponent.DIALOG_ID_MODIFICA).modal({
              backdrop: "static",
              keyboard: false,
            });
            this.selectedStatoSala = operation.stato;
            this.fromDate = new Date(operation.stato.tsBegin);
            this.toDate = new Date(operation.stato.tsEnd);
            let beginDateHrs = this.fromDate.getHours().toString();
            let beginDateMin = this.fromDate.getMinutes().toString();
            let endDateHrs = this.toDate.getHours().toString();
            let endDateMin = this.toDate.getMinutes().toString();
            this.hrBegin =
              (beginDateHrs.length == 1 ? "0" + beginDateHrs : beginDateHrs) +
              ":" +
              (beginDateMin.length == 1 ? "0" + beginDateMin : beginDateMin);
            this.hrEnd =
              (endDateHrs.length == 1 ? "0" + endDateHrs : endDateHrs) +
              ":" +
              (endDateMin.length == 1 ? "0" + endDateMin : endDateMin);
            this.descrizione = operation.stato.descrizione;
            break;
          default:
            break;
        }
      });
    }
  }

  ngOnDestroy() {
    // SalaService vive quanto l'app: senza unsubscribe ogni ritorno su Ufficio aggiunge una subscription
    if (this.salaDetailStatusSubscription) {
      this.salaDetailStatusSubscription.unsubscribe();
    }
  }

  prenota() {
    this.errorMessage = null;

    if (this.fromDate > this.toDate) {
      this.errorMessage =
        "Data di fine periodo antecedente alla data di inizio";
      return;
    }

    let request: PrenotazioneSalaRequest = new PrenotazioneSalaRequest();
    request.dataDa = this.fromDate;
    request.dataA = this.toDate;
    this.checkHrBegin();
    this.checkHrEnd();
    if (
      this.hrBegin != null &&
      this.hrBegin.length == 5 &&
      this.hrEnd != null &&
      this.hrEnd.length == 5
    ) {
      request.hrBegin = this.hrBegin;
      request.hrEnd = this.hrEnd;
    }
    request.descrizione = this.descrizione;
    request.idSala = 1; //this.selectedStatoSala.idSala;
    this.busyProvider.showBusyIndicator();
    this.salaService.prenotaSala(this.userContext.srmToken, request).subscribe(
      () => {
        this.busyProvider.hideBusyIndicator();
        this.messageProvider.notifyMessage("Inserimento eseguito correttamente");
        this.closePrenota();
        this.ufficioService.fireRefreshEvent();
      },
      (error) => {
        this.busyProvider.hideBusyIndicator();
        this.errorMessage = this.retrieveError(error);
      }
    );
  }

  cancellaPrenotazione() {
    this.errorMessage = null;

    if (this.fromDate == null) {
      this.errorMessage = "Qualcosa è andato storto, chiudere e riprovare";
      return;
    }
    if (this.selectedStatoSala == null) {
      this.errorMessage = "Qualcosa è andato storto, chiudere e riprovare";
      return;
    }

    if (this.selectedStatoSala.idPrenotazione != null) {
      this.busyProvider.showBusyIndicator();
      this.salaService
        .liberaSala(
          this.userContext.srmToken,
          this.selectedStatoSala.idPrenotazione
        )
        .subscribe(
          () => {
            this.busyProvider.hideBusyIndicator();
            this.messageProvider.notifyMessage("Liberazione sala eseguita correttamente");
            this.closeCancella();
            this.ufficioService.fireRefreshEvent();
          },
          (error) => {
            this.busyProvider.hideBusyIndicator();
            this.errorMessage = this.retrieveError(error);
          }
        );
    } else {
      this.errorMessage = "Qualcosa è andato storto, chiudere e riprovare";
      return;
    }
  }

  modificaPrenotazione() {
    this.errorMessage = null;

    if (this.fromDate == null) {
      this.errorMessage = "Qualcosa è andato storto, chiudere e riprovare";
      return;
    }
    if (this.selectedStatoSala == null) {
      this.errorMessage = "Qualcosa è andato storto, chiudere e riprovare";
      return;
    }

    let request: PrenotazioneSalaRequest = new PrenotazioneSalaRequest();
    request.dataDa = this.fromDate;
    request.dataA = this.fromDate;
    this.checkHrBegin();
    this.checkHrEnd();
    if (
      this.hrBegin != null &&
      this.hrBegin.length == 5 &&
      this.hrEnd != null &&
      this.hrEnd.length == 5
    ) {
      request.hrBegin = this.hrBegin;
      request.hrEnd = this.hrEnd;
    }
    request.descrizione = this.descrizione;
    request.idSala = 1; //this.selectedStatoSala.idSala;
    if (this.selectedStatoSala.idPrenotazione != null) {
      this.busyProvider.showBusyIndicator();
      this.salaService
        .modificaPrenotazione(
          this.userContext.srmToken,
          request,
          this.selectedStatoSala.idPrenotazione
        )
        .subscribe(
          () => {
            this.busyProvider.hideBusyIndicator();
            this.messageProvider.notifyMessage("Modifica prenotazione sala eseguita correttamente");
            this.closeModifica();
            this.ufficioService.fireRefreshEvent();
          },
          (error) => {
            this.busyProvider.hideBusyIndicator();
            this.errorMessage = this.retrieveError(error);
          }
        );
    } else {
      this.errorMessage = "Qualcosa è andato storto, chiudere e riprovare";
      return;
    }
  }

  reset() {
    this.fromDate = new Date();
    this.toDate = new Date();
    this.selectedStatoSala = null;
    this.hrBegin = null;
    this.hrEnd = null;
    this.descrizione = null;
    this.errorMessage = null;
  }

  changeDateStart() {
    if (this.fromDate > this.toDate) {
      this.toDate = this.fromDate;
    }
  }

  closePrenota() {
    $("#" + DetailSalaComponent.DIALOG_ID_PRENOTA).modal("hide");
  }

  closeCancella() {
    this.reset();
    $("#" + DetailSalaComponent.DIALOG_ID_LIBERA).modal("hide");
  }

  closeModifica() {
    this.reset();
    $("#" + DetailSalaComponent.DIALOG_ID_MODIFICA).modal("hide");
  }

  shortcutHandler(event) {
    if (event.keyCode == 27) {
      // ESC
      this.closePrenota();
      this.closeCancella();
      this.closeModifica();
    }
  }

  checkHrBegin() {
    this.hrBegin = this.checkHours(this.hrBegin);
  }

  checkHrEnd() {
    this.hrEnd = this.checkHours(this.hrEnd);
  }

  checkHours(filtroHr: string) {
    let hr = filtroHr;
    if (hr == null || hr.trim() == "") {
      return null;
    }
    let index = hr.lastIndexOf(":");
    if (index > 0) {
      let tmp: string[] = hr.split(":");
      let hh = Number(tmp[0]);
      let mm = Number(tmp[1]);
      let m = (Math.round(mm / 15) * 15) % 60;
      let h = mm > 52 ? (hh === 23 ? 0 : ++hh) : hh;
      if (hh > 23 || mm > 59) {
        hr = null;
      } else {
        hr = ("00" + h).slice(-2) + ":" + ("00" + m).slice(-2);
      }
    }
    return hr;
  }
}



// WEBPACK FOOTER //
// ./src/app/sala-detail/sala-detail.component.ts